module.exports = __webpack_public_path__ + "img/uniclass.1bd7ae5a.svg";